// Import utilities
const {
	isDefined
} = _uo.utility;

/**
 * Determines if the user can schedule an action or add delay
 *
 * @return {Boolean} True if the user can schedule an action or add delay
 */
const canManageSchedule = () => {
	return UncannyAutomator._site.automator.has_pro;
};

export default canManageSchedule;
